import { Component } from '@angular/core';
//import { AuthService } from '@app/services/auth/auth.service';
import { OidcSecurityService } from 'angular-auth-oidc-client';

@Component({
  selector: 'app-unauthorized',
  templateUrl: 'unauthorized.component.html',
  styleUrls: ['unauthorized.component.css']
})
export class UnauthorizedComponent {
    constructor(private oidcSecurityService: OidcSecurityService) {
    //this.service.startSigninMainWindow();
    this.oidcSecurityService.authorize();
  }

}
